module.exports = __webpack_public_path__ + "static/media/debugger_panel.92f513ff.png";